import { render, staticRenderFns } from "./AHead.vue?vue&type=template&id=8470d622&scoped=true&"
import script from "./AHead.vue?vue&type=script&lang=js&"
export * from "./AHead.vue?vue&type=script&lang=js&"
import style0 from "./AHead.vue?vue&type=style&index=0&id=8470d622&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8470d622",
  null
  
)

export default component.exports